import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../shared/services/core/api.service';
import { CardLinkAffiliatesStore } from './card-link-affiliates.store';
import { CardLinkAffiliate } from './models/card-link-affiliate.model';

@Injectable({ providedIn: 'root' })
export class CardLinkAffiliatesService {
  constructor(private cardLinkAffiliatesStore: CardLinkAffiliatesStore, private api: ApiService) {}

  /**
   * fatch the all affiliate Brands and put them into the store
   * depending on the clubId and lcid.
   * @param clubId take as param and fatch affiliate related to club.
   * @param lcid is the current language ID
   * @returns request to get data and add to store
   */

  fetchAffiliates(clubId: number, lcid: string) {
    const request$: Observable<CardLinkAffiliate[]> = this.api.get<CardLinkAffiliate>(`affiliates/${clubId}/${lcid}`).pipe(
      tap((entities) => {
        this.cardLinkAffiliatesStore.set(entities);
      })
    );
    return cacheable(this.cardLinkAffiliatesStore, request$);
  }
}
